'use client';
import React from 'react';
import { motion } from 'framer-motion';
import s from './AvisoProgramaDeReferidos.module.css';
import { AvisoPrograma } from '@/types/model';

const AvisoProgramaDeReferidos = ({ title, preTitle, description, items }: AvisoPrograma) => {
  return (
    <motion.div className={s.container} initial={{ opacity: 0 }} whileInView={{ opacity: 1 }}>
      <div className={s.container__wrapper}>
        <div>
          <h2 className={s.container__wrapper__pre}>{preTitle}</h2>
          <h1 className={s.container__wrapper__title}>{title}</h1>
        </div>
        <div
          className={s.container__wrapper__description_container}
          dangerouslySetInnerHTML={{ __html: description }}
        />

        {items.map((item, index) => {
          return (
            <div className={s.container__wrapper__item} key={index}>
              <h4>{item.label}</h4>
              <p>{item.data}</p>
              {item.table && (
                <div
                  className={s.container__wrapper__item__table_container}
                  dangerouslySetInnerHTML={{ __html: item.table }}
                />
              )}
            </div>
          );
        })}
      </div>
      <div className={s.container__forma}></div>
    </motion.div>
  );
};

export default AvisoProgramaDeReferidos;
